
import MediaCarousel from "@/components/sliders/MediaCarousel.vue";
import Overview from "@/components/pageContent/Overview.vue";
import AddWatchlistIcon from "@/components/buttons/AddWatchlistIcon.vue";

export default {
	name: "ActorPage",
	components: {
		MediaCarousel,
		AddWatchlistIcon,
		Overview
	},
	computed: {
		storeActor() {
			return this.$store.state.media.media;
		},
		placeholderIconSize() {
			switch (this.$vuetify.breakpoint.name) {
				case "xs":
					return "150";
				case "sm":
					return "180";
				case "md":
					return "200";
				case "lg":
					return "230";
				case "xl":
					return "230";
			}
		},
		formatBirthday() {
			if (this.storeActor.info && this.storeActor.info.birthday) {
				const dateArray = this.storeActor.info.birthday.split("-");
				return dateArray.reverse().join("-");
			}
		},
		formatDeathday() {
			if (this.storeActor.info && this.storeActor.info.deathday) {
				const dateArray = this.storeActor.info.deathday.split("-");
				return dateArray.reverse().join("-");
			}
		},
		formatRole() {
			if (this.storeActor.info.known_for_department === "Acting") return "Actor";
			if (this.storeActor.info.known_for_department === "Directing") return "Director";
			if (this.storeActor.info.known_for_department === "Sound") return "Composer";
			if (this.storeActor.info.known_for_department === "Writing") return "Writer";
			if (this.storeActor.info.known_for_department === "Production") return "Producer";
			if (this.storeActor.info.known_for_department === "Editing") return "Editor";
			return this.storeActor.info.known_for_department;
		},
		calculateAge() {
			if (this.storeActor.info && this.storeActor.info.birthday) {
				const dateArray = this.storeActor.info.birthday.split("-");
				const formattedBirthday = dateArray.join("/");
				var today = new Date();
				var birthDate = new Date(formattedBirthday);
				var personAge = today.getFullYear() - birthDate.getFullYear();
				var m = today.getMonth() - birthDate.getMonth();
				if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
					personAge--;
				}
				return personAge;
			}
		},
		alsoKnownAs() {
			if (this.storeActor.info && this.storeActor.info.also_known_as) return this.storeActor.info.also_known_as.length !== 0;
		}
	}
};
